function Cinema_booking_table(element) {

  this.select_show = document.querySelector('#show_id');
  this.select_show_div = this.select_show.closest('.c-form-element');


  this.init = function () {

    /* A. hide table options if "what" is film only
    *  B. show table options if A allows it, and there's a table booking show */

    const that = this;
    document.querySelector('#form_what').addEventListener('click', function (e) {
      that.update_table_options();
    });
    that.select_show.addEventListener('change', function() {
      that.update_what_options();
      that.update_table_options();
    });
    this.update_table_options();
  };

  this.update_what_options = function () {
    const film = document.querySelector('#form_what-f');
    const essen = document.querySelector('#form_what-e');
    const film_und_essen = document.querySelector('#form_what-fe');

    if (this.film_has_table_booking()) {
      // enable fe, e
      essen.closest('li').classList.remove('hidden');
      film_und_essen.closest('li').classList.remove('hidden');
      film.checked = 0;
    } else {
      essen.closest('li').classList.add('hidden');
      film_und_essen.closest('li').classList.add('hidden');
      film_und_essen.checked = 0;
      essen.checked = 0;
      film.checked = 1;
    }
    this.validate(document.querySelector('#form_what'));
  };

  this.update_table_options = function () {
    const table_options = document.querySelector('#table_booking_flag').closest('.c-form-element');
    const nur_film = document.querySelector('#form_what-f').checked;
    const essen_undoder_film = (document.querySelector('#form_what-e').checked || document.querySelector('#form_what-fe').checked);
    let do_show = (essen_undoder_film === true || this.film_has_table_booking());
    do_show = do_show && (nur_film !== true);
    console.log('upd tbl opt: nur_film = ' + nur_film);

    if (do_show) {
      table_options.classList.remove('hidden');
    } else {
      table_options.classList.add('hidden');
      this.clear_table_options();
    }
  };

  this.film_has_table_booking = function() {
    this.dataTableShowIds = [];
    if (this.select_show_div.dataset.tableShowIds.length > 0) {
      this.dataTableShowIds = this.select_show_div.dataset.tableShowIds.split(',');
    }

    const result = /*this.select_show.value > 0 &&*/ this.dataTableShowIds.includes(this.select_show.value);
    // console.log('Film has Table Booking: ' + result);
    return result;
  };

  this.setSelectValue = function (id, value) {
    const element = document.querySelector(id);
    element.value = value;
    this.validate(element);
  };

  this.clear_table_options = function () {
    document.querySelectorAll('#table_booking_flag input').forEach(function (currentValue) {
      currentValue.checked = false;
    });
  };

  this.validate = function (element) {
    element.dispatchEvent(new Event('i4:validate'));
  };
}
